/* eslint no-underscore-dangle: 0 */
/* eslint no-param-reassign: 0 */

// Como en el set legacy, las variables no se declaran todas juntas en init(): las declara
// cada bloque que les asigna un valor (`let x = 0`), así una variable usada sin definirla
// no declara nada, igual que prod.

export const declareVariable = (generator, name) => {
  generator.definitions_[`declare_var${name}`] = `let ${name} = 0\n`;
};

// Blockly ya dejó su `var a, b;` en definitions_.variables cuando corre esto;
// se saca para que la única declaración sea la de los bloques de arriba.
export const dropBlocklyVariableDeclarations = (definitions) => {
  const copy = definitions;
  delete copy.variables;

  return copy;
};

export default declareVariable;
